enum FieldNames {
  REIMBURSEMENT_TYPE = "reimbursementType"
}

export default FieldNames
